import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../../Defaults/Text';
import { FlexCol } from '../../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow } from '../../General/Table';
import { getOrderDetailItemInfo } from '../../../../utilities/selectors';
import { formatPrice, formatPriceToString, prop } from '../../../../utilities';

export interface Props {
  item?: any;
  theme: any;
}

function OrderDetailItemRow({ item }: Props) {
  const {
    ordernr,
    name,
    image,
    currency,
    totalPriceWithoutVat,
    unitprice,
    quantity,
    productUrl,
    unitPriceWithoutVat,
    outerPayload,
  } = getOrderDetailItemInfo(item);
  return (
    <StyledTableRow>
      <ImageNameTableTd>
        <Link to={productUrl}>
          <Image alt={`${__('Obrázok ku produktu')} ${name}`} src={image} />
        </Link>
        <NameInputWrapper>
          <StyledLink to={productUrl}>
            <Name>{name}</Name>
          </StyledLink>
          <OrderNr>{ordernr}</OrderNr>
        </NameInputWrapper>
      </ImageNameTableTd>
      <StyledTableTd align={'right'}>
        <CellText>{formatPrice(unitPriceWithoutVat, currency)}</CellText>
      </StyledTableTd>
      <StyledTableTd align={'center'}>
        <CellText>{`${quantity} ${__('ks')}`}</CellText>
      </StyledTableTd>
      <StyledTableTd align={'center'}>
        <CellTextDelivered>
          {+prop(outerPayload, 'delivered') > 0
            ? `${prop(outerPayload, 'delivered')} ${__('ks')}`
            : '-'}
        </CellTextDelivered>
      </StyledTableTd>
      <StyledTableTd align={'center'}>
        <CellTextNotDelivered>
          {+prop(outerPayload, 'not_delivered') > 0
            ? `${prop(outerPayload, 'not_delivered')} ${__('ks')}`
            : '-'}
        </CellTextNotDelivered>
      </StyledTableTd>
      <StyledTableTd align={'center'}>
        <CellTextNotDelivered>
          {+prop(outerPayload, 'cancelled') > 0
            ? `${prop(outerPayload, 'cancelled')} ${__('ks')}`
            : '-'}
        </CellTextNotDelivered>
      </StyledTableTd>
      <StyledTableTd align={'right'}>
        <CellText fontWeight={500}>
          {formatPrice(totalPriceWithoutVat, currency)}
        </CellText>
      </StyledTableTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)<{ align?: string }>`
  text-align: ${({ align }) => (align ? align : 'left')};
  padding: ${rem(16)} ${rem(24)};
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border: 0;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
`;

const CellText = styled(TextP)<{ fontWeight: number }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '400')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CellTextDelivered = styled(CellText)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.successColor};
`;

const CellTextNotDelivered = styled(CellText)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dangerColor};
`;

export const Note = styled(CellText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const Image = styled.img`
  width: ${rem(56)};
  height: ${rem(56)};
  max-width: initial;
  margin-right: ${rem(16)};
`;

const NameInputWrapper = styled(FlexCol)`
  max-width: ${rem(500)};

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(220)};
  `}

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(130)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(200)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  margin-bottom: ${rem(4)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: ${rem(400)}; */
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
    text-decoration: underline;
  }

  /* ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `} */
`;

export const OrderNr = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.colors.placeholder};
  text-align: left;
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 300;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const WithThemeRow: any = withTheme(OrderDetailItemRow);
export { WithThemeRow as DsiOrderDetailItemRow };
